import React, { createContext, ReactNode, useContext } from "react";

export interface PageHeaderConfig {
  title: string;
  childTitle?: string;
  subtitle?: string;
  icon?: ReactNode;
  onBack?: () => void;
}

interface PageHeaderContextValue {
  pageHeader: PageHeaderConfig | null;
  setPageHeader: React.Dispatch<React.SetStateAction<PageHeaderConfig | null>>;
}

export const PageHeaderContext = createContext<PageHeaderContextValue>({
  pageHeader: null,
  setPageHeader: () => undefined,
});

export const usePageHeader = () => useContext(PageHeaderContext);
